import { createContext, useState } from "react";

// Create a Context object for managing workflow state
export const WorkflowContext = createContext(null);

const WorkflowProvider = ({ children }) => {
  // State for storing workflow data
  const [workflow, setWorkflow] = useState({});

  // State for controlling whether certain elements are disabled
  const [isDisabled, setIsDisabled] = useState(false);

  return (
    // Provide the workflow state and functions to children components
    <WorkflowContext.Provider
      value={{
        workflow, // Current workflow data
        setWorkflow, // Function to update the workflow data
        isDisabled, // Boolean indicating whether elements are disabled
        setIsDisabled, // Function to update the disabled state
      }}
    >
      {children}
    </WorkflowContext.Provider>
  );
};

export default WorkflowProvider;
